class Labels {
  //Labels
  static LBL_YES_LOGOUT="LBL_YES_LOGOUT";
  static LBL_NO_STAY="LBL_NO_STAY";
  static LBL_SALES_REPRESENTATIVE_MOBILE_NUMBER="LBL_SALES_REPRESENTATIVE_MOBILE_NUMBER";
  static LBL_SALES_REPRESENTATIVE_EMAIL="LBL_SALES_REPRESENTATIVE_EMAIL";
  static LBL_SALES_REPRESENTATIVE_SECTION="LBL_SALES_REPRESENTATIVE_SECTION";
  static LBL_PLAN_NAME="LBL_PLAN_NAME";
  static LBL_FINANCING_ARRANGMENT="LBL_FINANCING_ARRANGMENT";
  static LBL_ENTITY_DECLARATION_CONFIRM="LBL_ENTITY_DECLARATION_CONFIRM";
  static LBL_UNDER_B40_GROUP="LBL_UNDER_B40_GROUP";
  static LBL_ARE_YOU_MUSLIM="LBL_ARE_YOU_MUSLIM";
  static LBL_ENTITY_FORM_GENERATED="LBL_ENTITY_FORM_GENERATED";
  static ERR_CALCULATE_TO_PREMIUM="ERR_CALCULATE_TO_PREMIUM";
  static LBL_SUBMISSION_SUCCESS_4P_DESC="LBL_SUBMISSION_SUCCESS_4P_DESC";
  static LBL_TERM_OF_COVERAGE="LBL_TERM_OF_COVERAGE";
  static LBL_ENTITY_DECLARATION_FORM="LBL_ENTITY_DECLARATION_FORM";
  static ERR_ENTITY_DECLARATION="ERR_ENTITY_DECLARATION";
  static LBL_TAX_RETURN_OTHER_COUNTRY_PD="LBL_TAX_RETURN_OTHER_COUNTRY_PD";
  static LBL_LOAN_PRODUCT_DETAILS="LBL_LOAN_PRODUCT_DETAILS";
  static LBL_ANY_CHILD="LBL_ANY_CHILD";
  static LBL_ANY_BENEFICIARY="LBL_ANY_BENEFICIARY";
  static LBL_BENEFICIARY_ACKNOWNLEGEMENT="LBL_BENEFICIARY_ACKNOWNLEGEMENT";
  static LBL_NOMINATION_BENEFICIARY_FORM_GENERATED="LBL_NOMINATION_BENEFICIARY_FORM_GENERATED";
  static LBL_TICK_ALL="LBL_TICK_ALL";
  static LBL_CLOSE="LBL_CLOSE";
  static LBL_OTP_VERIFICATION_MOBILE="LBL_OTP_VERIFICATION_MOBILE";
  static LBL_OTP_VERIFICATION_EMAIL="LBL_OTP_VERIFICATION_EMAIL";
  static LBL_NO_SIGNATURE_FOUND="LBL_NO_SIGNATURE_FOUND";
  static LBL_NO_STAMP_FOUND="LBL_STAMP_FOUND";

  static LBL_COUNTRY_TAX_RESIDENCE="LBL_COUNTRY_TAX_RESIDENCE";
  static LBL_TIN="LBL_TIN";
  static LBL_INDICATE_REASON_OF_TIN="LBL_INDICATE_REASON_OF_TIN";
  static LBL_REGISTERED_NAME_COMPANY="LBL_REGISTERED_NAME_COMPANY";
  static LBL_NEW_COMPANY_REGISTRATION_NO="LBL_NEW_COMPANY_REGISTRATION_NO";
  static LBL_OLD_COMPANY_REGISTRATION_NO="LBL_OLD_COMPANY_REGISTRATION_NO";
  static LBL_COMPANY_COUNTRY="LBL_COMPANY_COUNTRY";
  static LBL_COMPANY_TEL="LBL_COMPANY_TEL";
  static LBL_COMPANY_EMAIL="LBL_COMPANY_EMAIL";
  static LBL_COMPANY_TYPE="LBL_COMPANY_TYPE";
  static LBL_PROVIDE_DETAIL="LBL_PROVIDE_DETAIL";
  static LBL_LISTED_OR_TRADE_STOCK_EXCHANGE="LBL_LISTED_OR_TRADE_STOCK_EXCHANGE";
  static LBL_USA_COMPANY_OWNERSHIP="LBL_USA_COMPANY_OWNERSHIP";
  static LBL_COMPANY_SELECT_GROUP="LBL_COMPANY_SELECT_GROUP";
  static LBL_TAX_RETURN_OTHER_COUNTRY="LBL_TAX_RETURN_OTHER_COUNTRY";

  static LBL_ENTITY_TYPE="LBL_ENTITY_TYPE";
  static LBL_NAME_SECURITY_MARKET="LBL_NAME_SECURITY_MARKET";
  static LBL_NAME_TRADED_CORPORATION="LBL_NAME_TRADED_CORPORATION";

  static LBL_COMPANY_DETAILS="LBL_COMPANY_DETAILS";
  static LBL_CERTIFICATE_TERM="LBL_CERTIFICATE_TERM";
  static LBL_COVERAGE_AMOUNT="LBL_COVERAGE_AMOUNT";
  static LBL_QUOTATION_DATE="LBL_QUOTATION_DATE";
  static LBL_STEP4_REVIEW_SUBMIT="LBL_STEP4_REVIEW_SUBMIT";
  static LBL_INSURANCE_TYPE="LBL_INSURANCE_TYPE";
  static LBL_ARRANGEMENT="LBL_ARRANGEMENT";
  static LBL_COMPANY_INSURED_MEMBER="LBL_COMPANY_INSURED_MEMBER";
  static LBL_LOADING_DETAILS="LBL_LOADING_DETAILS";

  static LBL_STEP2_PRODUCT_SELECTION="LBL_STEP2_PRODUCT_SELECTION";
  static LBL_STEP3_PRODUCT_DETAILS="LBL_STEP3_PRODUCT_DETAILS";
  static ERROR_REQUEST_LOGIN_LIMIT="ERROR_REQUEST_LOGIN_LIMIT";
  static LBL_TRANSACTION_DELETE_DIALOG_TITLE =
    "LBL_TRANSACTION_DELETE_DIALOG_TITLE";
  static LBL_TRANSACTION_DELETE_DIALOG_DESC =
    "LBL_TRANSACTION_DELETE_DIALOG_DESC";
  static LBL_TRANSACTION_DELETE_YES = "LBL_TRANSACTION_DELETE_YES";
  static LBL_FAILED_SEND_OTP = "LBL_FAILED_SEND_OTP";
  static LBL_FAILED_RESEND_OTP = "LBL_FAILED_RESEND_OTP";

  static LBL_PRODUCT_DETAILS = "LBL_PRODUCT_DETAILS";
  static LBL_PREVIEW_SUBMIT = "LBL_PREVIEW_SUBMIT";
  static LBL_INVALID_CREDENTIALS = "LBL_INVALID_CREDENTIALS";
  static LBL_WRONG_OTP = "LBL_WRONG_OTP";
  static LBL_DUPLICATED_LOGIN = "LBL_DUPLICATED_LOGIN";
  static LBL_PRINT = "LBL_PRINT";
  static LBL_DOWNLOAD = "LBL_DOWNLOAD";
  static LBL_PROPOSAL_GENERATED = "LBL_PROPOSAL_GENERATED";
  static LBL_STEP_CONFIRMATION = "LBL_STEP_CONFIRMATION";
  static LBL_CONFIRM_SIGNATURE = "LBL_CONFIRM_SIGNATURE";
  static LBL_CLICK_SIGN_ICON = "LBL_CLICK_SIGN_ICON";
  static LBL_TOKEN_INACTIVE = "LBL_TOKEN_INACTIVE";
  static LBL_TOKEN_RENEWED = "LBL_TOKEN_RENEWED";
  static LBL_TOKEN_LOGOUT = "LBL_TOKEN_LOGOUT";
  static LBL_TOKEN_INVALID = "LBL_TOKEN_INVALID";
  static LBL_REF_TOKEN_EXPIRED = "LBL_REF_TOKEN_EXPIRED";
  static LBL_REF_TOKEN_INVALID = "LBL_REF_TOKEN_INVALID";
  static LBL_OPTIONAL_DOCUMENTS = "LBL_OPTIONAL_DOCUMENTS";
  static ERROR_INVALID_DEVICE = "ERROR_INVALID_DEVICE";
  static LBL_DECLARATION_ACKNOWLEGDE_TOOLTIP =
    "LBL_DECLARATION_ACKNOWLEGDE_TOOLTIP";
  static LBL_DECLARATION_IMPORTANT_TOOLTIP =
    "LBL_DECLARATION_IMPORTANT_TOOLTIP";

  static ERR_TERMS_AND_CONDITION = "ERR_TERMS_AND_CONDITION";
  static ERR_SALUTATION = "ERR_SALUTATION";
  static ERR_GENDER = "ERR_GENDER";
  static ERR_NEWNRICNO = "ERR_NEWNRICNO";
  static ERR_OLDNRICNO = "ERR_OLDNRICNO";
  static MOBILE_COUNTRY_CODE = "MOBILE_COUNTRY_CODE";
  static RESIDENCETELNO = "RESIDENCETELNO";
  static BUSINESSTELNO = "BUSINESSTELNO";
  static COUNTRYCODE = "COUNTRYCODE";
  static ALL_FIELDS_MARKED = "ALL_FIELDS_MARKED";
  static LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_2 =
    "LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_2";
  static LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_3 =
    "LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_3";
  static LBL_BACK = "LBL_BACK";
  static LBL_EMAIL_QUOTATION = "LBL_EMAIL_QUOTATION";
  static LBL_SEND_EMAIL_QUOTATION = "LBL_SEND_EMAIL_QUOTATION";
  static LBL_EMAIL_QUOTATION_DIALOG_TITLE = "LBL_EMAIL_QUOTATION_DIALOG_TITLE";
  static LBL_EMAIL_QUOTATION_DIALOG_DESC = "LBL_EMAIL_QUOTATION_DIALOG_DESC";
  static ERROR_CORRESPONDENCE_ADDRESS = "ERROR_CORRESPONDENCE_ADDRESS";
  static LBL_RESIDENTIAL_ADDRESS_1 = "LBL_RESIDENTIAL_ADDRESS_1";
  static LBL_RESIDENTIAL_ADDRESS_2 = "LBL_RESIDENTIAL_ADDRESS_2";
  static LBL_RESIDENTIAL_ADDRESS_3 = "LBL_RESIDENTIAL_ADDRESS_3";

  static ERROR_RESIDENTIAL_ADDRESS = "ERROR_RESIDENTIAL_ADDRESS";
  static ERROR_RESIDENTIAL_ADDRESS_1 = "ERROR_RESIDENTIAL_ADDRESS_1";
  static ERROR_RESIDENTIAL_ADDRESS_2 = "ERROR_RESIDENTIAL_ADDRESS_2";
  static ERROR_RESIDENTIAL_ADDRESS_3 = "ERROR_RESIDENTIAL_ADDRESS_3";
  static ERROR_RESIDENTIAL_ADDRESS_4 = "ERROR_RESIDENTIAL_ADDRESS_4";

  static LBL_IMPORTANT_NOTICE_PENDING_REVIEW_PROPOSAL_DETAILS =
    "LBL_IMPORTANT_NOTICE_PENDING_REVIEW_PROPOSAL_DETAILS";
  static LBL_IMPORTANT_NOTICE_DESC_PENDING_REVIEW_PROPOSAL_DETAILS =
    "LBL_IMPORTANT_NOTICE_DESC_PENDING_REVIEW_PROPOSAL_DETAILS";

  static LBL_IMPORTANT_NOTICE_PENDING_SUBMISSION_PROPOSAL_DETAILS =
    "LBL_IMPORTANT_NOTICE_PENDING_SUBMISSION_PROPOSAL_DETAILS";
  static LBL_IMPORTANT_NOTICE_DESC_PENDING_SUBMISSION_PROPOSAL_DETAILS =
    "LBL_IMPORTANT_NOTICE_DESC_PENDING_SUBMISSION_PROPOSAL_DETAILS";

  static LBL_IMPORTANT_NOTICE_SUBMITTED_PROPOSAL_DETAILS =
    "LBL_IMPORTANT_NOTICE_SUBMITTED_PROPOSAL_DETAILS";
  static LBL_IMPORTANT_NOTICE_DESC_SUBMITTED_PROPOSAL_DETAILS =
    "LBL_IMPORTANT_NOTICE_DESC_SUBMITTED_PROPOSAL_DETAILS";

  static LBL_CONTACT = "LBL_CONTACT";
  static LBL_CONTACT_INFO = "LBL_CONTACT_INFO";
  static LBL_CONTACT_DETAILS = "LBL_CONTACT_DETAILS";
  static LBL_CONTACT_DETAILS_DESC = "LBL_CONTACT_DETAILS_DESC";
  static LBL_CREATE_CONTACT = "LBL_CREATE_CONTACT";
  static LBL_CREATE_CONTACT_DESC = "LBL_CREATE_CONTACT_DESC";
  static LBL_DELETE_CONTACT = "LBL_DELETE_CONTACT";
  static LBL_UPDATE_CONTACT = "LBL_UPDATE_CONTACT";
  static LBL_SELECT_CONTACT = "LBL_SELECT_CONTACT";
  static LBL_SELECT_CONTACT_CREATE_QUOTATION =
    "LBL_SELECT_CONTACT_CREATE_QUOTATION";
  static LBL_LIFE_ASSURED_NAME = "LBL_LIFE_ASSURED_NAME";
  static LBL_LIFE_ASSURED_NAME_PLACEHOLDER_FIELD =
    "LBL_LIFE_ASSURED_NAME_PLACEHOLDER_FIELD";
  static LBL_PURPOSE_OF_PROPOSAL = "LBL_PURPOSE_OF_PROPOSAL";
  static LBL_PURPOSE_OF_PROPOSAL_PLACEHOLDER_FIELD =
    "LBL_PURPOSE_OF_PROPOSAL_PLACEHOLDER_FIELD";
  static LBL_NATIONALITY = "LBL_NATIONALITY";
  static LBL_SAME_CORRES_ADDRESS = "LBL_SAME_CORRES_ADDRESS";
  static LBL_OCCUPATION_EXACT_DUTY = "LBL_OCCUPATION_EXACT_DUTY";
  static LBL_SEARCH_CONTACT_PLACEHOLDER = "LBL_SEARCH_CONTACT_PLACEHOLDER";
  static LBL_CREATE_NEW_CONTACT = "LBL_CREATE_NEW_CONTACT";
  static LBL_CONTACT_DELETE_DIALOG_TITLE = "LBL_CONTACT_DELETE_DIALOG_TITLE";
  static LBL_CONTACT_DELETE_DIALOG_DESC = "LBL_CONTACT_DELETE_DIALOG_DESC";
  static LBL_CONTACT_DELETE_YES = "LBL_CONTACT_DELETE_YES";
  static LBL_SERVICE_DESK_TITLE = "LBL_SERVICE_DESK_TITLE";
  static LBL_SERVICE_DESK_DESC = "LBL_SERVICE_DESK_DESC";
  static LBL_TECHNICAL_SUPPORT_HOURS = "LBL_TECHNICAL_SUPPORT_HOURS";
  static LBL_MONDAY_TO_SUNDAY_EX_HOLIDAYS = "LBL_MONDAY_TO_SUNDAY_EX_HOLIDAYS";
  static LBL_PHONE = "LBL_PHONE";

  static LBL_PRODUCT_SELECTION = "LBL_PRODUCT_SELECTION";
  static LBL_PRODUCT_SELECTION_PLACEHOLDER_FIELD =
    "LBL_PRODUCT_SELECTION_PLACEHOLDER_FIELD";

  static LBL_PAYMENT_FREQUENCY = "LBL_PAYMENT_FREQUENCY";
  static LBL_PAYMENT_FREQUENCY_PLACEHOLDER_FIELD =
    "LBL_PAYMENT_FREQUENCY_PLACEHOLDER_FIELD";

  static LBL_PAYMENT_METHOD = "LBL_PAYMENT_METHOD";
  static LBL_PAYMENT_METHOD_PLACEHOLDER_FIELD =
    "LBL_PAYMENT_METHOD_PLACEHOLDER_FIELD";

  static LBL_PREMIUM_BACK_DATE = "LBL_PREMIUM_BACK_DATE";
  static LBL_INCEPTION_DATE = "LBL_INCEPTION_DATE";

  static LBL_PAYMENT_MODE = "LBL_PAYMENT_MODE";

  static LBL_LOAN_ACCOUNT_NO = "LBL_LOAN_ACCOUNT_NO";
  static LBL_LOAN_AMOUNT = "LBL_LOAN_AMOUNT";
  static LBL_LOAN_TENURE = "LBL_LOAN_TENURE";
  static LBL_CONSTRUCTION_PERIOD = "LBL_CONSTRUCTION_PERIOD";
  static LBL_LOAN_INTEREST_RATE = "LBL_LOAN_INTEREST_RATE";
  static LBL_PRODUCT_NAME = "LBL_PRODUCT_NAME";
  static LBL_INITIAL_SUM_ASSURED = "LBL_INITIAL_SUM_ASSURED";
  static LBL_DEFERMENT_TERM = "LBL_DEFERMENT_TERM";
  static LBL_DEFERMENT_PERIOD = "LBL_DEFERMENT_PERIOD";
  static LBL_TERM_OF_COVERAGE_DEFERMENT_TERM =
    "LBL_TERM_OF_COVERAGE_DEFERMENT_TERM";
  static LBL_PAYMENT_OPTION = "LBL_PAYMENT_OPTION";
  static LBL_RESEND_EMAIL_OPT = "LBL_RESEND_EMAIL_OPT";
  static LBL_TRANSACTION_FAILED = "LBL_TRANSACTION_FAILED";
  static BTN_BACK_TO_LOGIN = "BTN_BACK_TO_LOGIN";
  static LBL_TOKEN_EXPIRED = "LBL_TOKEN_EXPIRED";
  static LBL_EMAIL_SENDED = "LBL_EMAIL_SENDED";
  static LBL_ERROR = "LBL_ERROR";
  static LBL_RESET_PASSWORD = "LBL_RESET_PASSWORD";
  static BTN_CANCEL = "BTN_CANCEL";
  static BTN_BACK_TO_QUOTATION = "BTN_BACK_TO_QUOTATION";
  static LBL_STEP3_REVIEW_SUBMIT = "LBL_STEP3_REVIEW_SUBMIT";
  static LBL_STEP3_REVIEW_SUBMIT_DESC = "LBL_STEP3_REVIEW_SUBMIT_DESC";
  static LBL_OTP_VERIFICATION_AGENT_TITLE = "LBL_OTP_VERIFICATION_AGENT_TITLE";
  static LBL_AGREE = "LBL_AGREE";
  static LBL_REFUND_PREMIUM_RIDER = "LBL_REFUND_PREMIUM_RIDER";
  static LBL_SINGLE_PREMIUM_TO_BE_ASSURED = "LBL_SINGLE_PREMIUM_TO_BE_ASSURED";

  static LBL_YES_CANCEL = "LBL_YES_CANCEL";
  static LBL_NO_CONTINUE = "LBL_NO_CONTINUE";
  static LBL_CANCEL_DIALOG_TITLE = "LBL_CANCEL_DIALOG_TITLE";
  static LBL_CANCEL_DIALOG_DESC = "LBL_CANCEL_DIALOG_DESC";
  static LBL_SUBMIT_PROPOSAL = "LBL_SUBMIT_PROPOSAL";
  static LBL_SUBMIT_PROPOSAL_REMARK = "LBL_SUBMIT_PROPOSAL_REMARK";
  static LBL_PROPOSAL_SUBMISSION_SUCCESSFUL_TITLE =
    "LBL_PROPOSAL_SUBMISSION_SUCCESSFUL_TITLE";
  static LBL_PROPOSAL_SUBMISSION_SUCCESSFUL_DESC =
    "LBL_PROPOSAL_SUBMISSION_SUCCESSFUL_DESC";
  static LBL_REVIEWED_SIGNED = "LBL_REVIEWED_SIGNED";
  static LBL_SMS_SENDED = "LBL_SMS_SENDED";
  static LBL_RETRY_IN = "LBL_RETRY_IN";
  static LBL_LINK_EXPIRED = "LBL_LINK_EXPIRED";
  static LBL_PROPOSAL_LINK_EXPIRED = "LBL_PROPOSAL_LINK_EXPIRED";
  static LBL_PROPOSAL_LINK_EXPIRED_DESC = "LBL_PROPOSAL_LINK_EXPIRED_DESC";

  static ERROR_CORRESPONDENCE_ADDRESS_1 = "ERROR_CORRESPONDENCE_ADDRESS_1";
  static ERROR_CORRESPONDENCE_ADDRESS_2 = "ERROR_CORRESPONDENCE_ADDRESS_2";
  static ERROR_CORRESPONDENCE_ADDRESS_3 = "ERROR_CORRESPONDENCE_ADDRESS_3";
  static ERROR_CORRESPONDENCE_ADDRESS_4 = "ERROR_CORRESPONDENCE_ADDRESS_4";

  static ERROR_MOBILE_NUMBER = "ERROR_MOBILE_NUMBER";
  static ERROR_EMAIL_ADDRESS_1 = "ERROR_EMAIL_ADDRESS_1";
  static ERROR_EMAIL_ADDRESS_2 = "ERROR_EMAIL_ADDRESS_2";
  static ERROR_EMAIL_ADDRESS_3 = "ERROR_EMAIL_ADDRESS_3";
  static ERROR_EMAIL_ADDRESS_4 = "ERROR_EMAIL_ADDRESS_4";
  static ERROR_EMAIL_ADDRESS_5 = "ERROR_EMAIL_ADDRESS_5";

  static LBL_DOCUMENT_CATEGORY = "LBL_DOCUMENT_CATEGORY";
  static LBL_DOCUMENT_CATEGORY_PLACEHOLDER_FIELD =
    "LBL_DOCUMENT_CATEGORY_PLACEHOLDER_FIELD";

  static ERROR_OCCUPATION_CLASS = "ERROR_OCCUPATION_CLASS";
  static LBL_OCCUPATION_CLASS = "LBL_OCCUPATION_CLASS";
  static LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_1 =
    "LBL_MALAYSIA_CORRESPONDENCE_ADDRESS_1";
  static LBL_EMPLOYER_CORRESPONDENCE_ADDRESS =
    "LBL_EMPLOYER_CORRESPONDENCE_ADDRESS";
  static LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_1 =
    "LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_1";
  static LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_2 =
    "LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_2";
  static LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_3 =
    "LBL_EMPLOYER_CORRESPONDENCE_ADDRESS_3";

  static LBL_CORRESPONDENCE_ADDRESS_1 = "LBL_CORRESPONDENCE_ADDRESS_1";
  static LBL_CORRESPONDENCE_ADDRESS_2 = "LBL_CORRESPONDENCE_ADDRESS_2";
  static LBL_CORRESPONDENCE_ADDRESS_3 = "LBL_CORRESPONDENCE_ADDRESS_3";
  static LBL_OTHER_COUNTRY = "LBL_OTHER_COUNTRY";
  static LBL_YEARS_SMOKED = "LBL_YEARS_SMOKED";

  static LBL_CREATED_DATE = "LBL_CREATED_DATE";
  static LBL_LAST_UPDATED = "LBL_LAST_UPDATED";

  static LBL_PORTAL_VERSION = "LBL_PORTAL_VERSION";
  static LBL_SUPPORT_EMAIL_HELPDESK = "LBL_SUPPORT_EMAIL_HELPDESK";

  static LBL_QUOTATION_DELETE_DIALOG_TITLE =
    "LBL_QUOTATION_DELETE_DIALOG_TITLE";
  static LBL_QUOTATION_DELETE_DIALOG_DESC = "LBL_QUOTATION_DELETE_DIALOG_DESC";
  static LBL_QUOTATION_DELETE_YES = "LBL_QUOTATION_DELETE_YES";

  static LBL_PROPOSAL_DELETE_DIALOG_TITLE = "LBL_PROPOSAL_DELETE_DIALOG_TITLE";
  static LBL_PROPOSAL_DELETE_DIALOG_DESC = "LBL_PROPOSAL_DELETE_DIALOG_DESC";
  static LBL_PROPOSAL_DELETE_YES = "LBL_PROPOSAL_DELETE_YES";

  static LBL_DELETE_NO = "LBL_DELETE_NO";

  static LBL_SALES_REPRESENTATIVE_DECLARATION_TITLE =
    "LBL_SALES_REPRESENTATIVE_DECLARATION_TITLE";
  static LBL_SALES_REPRESENTATIVE_DECLARATION_DESC =
    "LBL_SALES_REPRESENTATIVE_DECLARATION_DESC";
  static LBL_REMINDER_TITLE = "LBL_REMINDER_TITLE";
  static LBL_REMINDER_DESC = "LBL_REMINDER_DESC";
  static LBL_SEND_REVIEW_REMARK = "LBL_SEND_REVIEW_REMARK";
  static LBL_SUBMIT_REQUOTATION = "LBL_SUBMIT_REQUOTATION";
  static LBL_REQUOTATION_SUCCESSFUL_TITLE = "LBL_REQUOTATION_SUCCESSFUL_TITLE";
  static LBL_STOP_WITHOUT_SAVING = "LBL_STOP_WITHOUT_SAVING";
  static LBL_QUOTATION_CREATION_SUCCESSFUL_TITLE =
    "LBL_QUOTATION_CREATION_SUCCESSFUL_TITLE";
  static LBL_QUOTATION_CREATION_SUCCESSFUL_DESC =
    "LBL_QUOTATION_CREATION_SUCCESSFUL_DESC";

  static LBL_SUPPORT_TEAM_HELPDESK = "LBL_SUPPORT_TEAM_HELPDESK";
  static LBL_TAKAFUL_MORTGAGE_PORTAL = "LBL_TAKAFUL_MORTGAGE_PORTAL";
  static LBL_HAVE_QUESTIONS = "LBL_HAVE_QUESTIONS";
  static LBL_MONDAY_TO_FRIDAY = "LBL_MONDAY_TO_FRIDAY";
  static LBL_OPERATION_HOURS = "LBL_OPERATION_HOURS";
  static LBL_QUERIES_ASSISTANCE = "LBL_QUERIES_ASSISTANCE";
  static LBL_STILL_NEED_HELP = "LBL_STILL_NEED_HELP";
  static LBL_FAQ_SEARCH_PLACEHOLDER = "LBL_FAQ_SEARCH_PLACEHOLDER";
  static LBL_FAQ = "LBL_FAQ";
  static LBL_ADD_TO_TABLE = "LBL_ADD_TO_TABLE";
  static LBL_UPDATE_TABLE = "LBL_UPDATE_TABLE";
  static LBL_DELETE = "LBL_DELETE";
  static LBL_ADD_DETAILS = "LBL_ADD_DETAILS";

  static LBL_NRIC = "LBL_NRIC";
  static LBL_PENDING_REVIEW = "LBL_PENDING_REVIEW";
  static LBL_TO_REVIEW_PROPOSAL = "LBL_TO_REVIEW_PROPOSAL";
  static LBL_RESEND_SMS = "LBL_RESEND_SMS";
  static LBL_VIEW_QUOTATION = "LBL_VIEW_QUOTATION";
  static LBL_UPDATE_PROPOSAL = "LBL_UPDATE_PROPOSAL";
  static LBL_CLIENTS_DETAILS = "LBL_CLIENTS_DETAILS";

  static LBL_VIEW_PROFILE = "LBL_VIEW_PROFILE";
  static LBL_CREATE_NEW_QUOTATION = "LBL_CREATE_NEW_QUOTATION";
  static LBL_CREATE_NEW_PROPOSAL = "LBL_CREATE_NEW_PROPOSAL";
  static LBL_SEARCH_PLACEHOLDER = "LBL_SEARCH_PLACEHOLDER";
  static LBL_RESULT = "LBL_RESULT";
  static LBL_RESULTS = "LBL_RESULTS";
  static LBL_SHOW = "LBL_SHOW";
  static LBL_PAGES = "LBL_PAGES";
  static LBL_PAGES = "LBL_PAGES";
  static LBL_PAGE = "LBL_PAGE";
  static LBL_SELECT_QUOTATION = "LBL_SELECT_QUOTATION";
  static LBL_SELECT_QUOTATION_DESC = "LBL_SELECT_QUOTATION_DESC";
  static LBL_GENERATED_QUOTATION = "LBL_GENERATED_QUOTATION";
  static LBL_STEP1_PROVIDE_DETAILS = "LBL_STEP1_PROVIDE_DETAILS";
  static LBL_STEP1_PROVIDE_DETAILS_DESC = "LBL_STEP1_PROVIDE_DETAILS_DESC";
  static LBL_MORTGAGE_DETAILS = "LBL_MORTGAGE_DETAILS";
  static LBL_PERSONAL_STATEMENT = "LBL_PERSONAL_STATEMENT";
  static LBL_E_CREDIT = "LBL_E_CREDIT";
  static LBL_DISCARD_DIALOG_TITLE = "LBL_DISCARD_DIALOG_TITLE";
  static LBL_DISCARD_DIALOG_DESC = "LBL_DISCARD_DIALOG_DESC";
  static LBL_STOP_WITHOUT_SAVING = "LBL_STOP_WITHOUT_SAVING";

  static LBL_REPRESENTATIVE_DETAILS = "LBL_REPRESENTATIVE_DETAILS";
  static LBL_REPRESENTATIVE_NAME = "LBL_REPRESENTATIVE_NAME";
  /* static LBL_REPRESENTATIVE_NAME_PLACEHOLDER_FIELD="LBL_REPRESENTATIVE_NAME_PLACEHOLDER_FIELD"; */

  static LBL_STAFF_ID = "LBL_STAFF_ID";
  /* static LBL_STAFF_ID_PLACEHOLDER_FIELD="LBL_STAFF_ID_PLACEHOLDER_FIELD"; */

  static LBL_REPRESENTATIVE_TAKAFUL_CODE = "LBL_REPRESENTATIVE_TAKAFUL_CODE";
  /* static LBL_REPRESENTATIVE_TAKAFUL_CODE_PLACEHOLDER_FIELD="LBL_REPRESENTATIVE_TAKAFUL_CODE_PLACEHOLDER_FIELD"; */

  static LBL_FINANCIAL_INSTITUTION_CODE = "LBL_FINANCIAL_INSTITUTION_CODE";
  /* static LBL_FINANCIAL_INSTITUTION_CODE_PLACEHOLDER_FIELD="LBL_FINANCIAL_INSTITUTION_CODE_PLACEHOLDER_FIELD"; */

  static LBL_REFERRAL_ID = "LBL_REFERRAL_ID";
  static LBL_REFERRAL_ID_PLACEHOLDER_FIELD =
    "LBL_REFERRAL_ID_PLACEHOLDER_FIELD";

  static LBL_FULLNAME_NRIC = "LBL_FULLNAME_NRIC";
  /* static LBL_FULLNAME_NRIC_PLACEHOLDER_FIELD="LBL_FULLNAME_NRIC_PLACEHOLDER_FIELD"; */

  static LBL_GENDER = "LBL_GENDER";
  static LBL_TITLE = "LBL_TITLE";
  static LBL_TITLE_PLACEHOLDER_FIELD = "LBL_TITLE_PLACEHOLDER_FIELD";

  static LBL_MARTIAL_STATUS = "LBL_MARTIAL_STATUS";
  static LBL_MARTIAL_STATUS_PLACEHOLDER_FIELD =
    "LBL_MARTIAL_STATUS_PLACEHOLDER_FIELD";

  static LBL_RACE = "LBL_RACE";
  static LBL_RACE_PLACEHOLDER_FIELD = "LBL_RACE_PLACEHOLDER_FIELD";

  static LBL_RELIGION = "LBL_RELIGION";
  static LBL_RELIGION_PLACEHOLDER_FIELD = "LBL_RELIGION_PLACEHOLDER_FIELD";

  static LBL_CURRENTLY_LIVING_MALAYSIA = "LBL_CURRENTLY_LIVING_MALAYSIA";
  static LBL_CORRESPONDENCE_ADDRESS = "LBL_CORRESPONDENCE_ADDRESS";
  static LBL_CORRESPONDENCE_ADDRESS_PLACEHOLDER_FIELD =
    "LBL_CORRESPONDENCE_ADDRESS_PLACEHOLDER_FIELD";

  static LBL_STATE = "LBL_STATE";
  static LBL_STATE_PLACEHOLDER_FIELD = "LBL_STATE_PLACEHOLDER_FIELD";

  static LBL_POSTCODE = "LBL_POSTCODE";
  static LBL_POSTCODE_PLACEHOLDER_FIELD = "LBL_POSTCODE_PLACEHOLDER_FIELD";

  static LBL_CITY = "LBL_CITY";
  static LBL_COUNTRY = "LBL_COUNTRY";
  static LBL_COUNTRY_OF_BIRTH = "LBL_COUNTRY_OF_BIRTH";

  static LBL_IS_MALAYSIA = "LBL_IS_MALAYSIA";

  static LBL_WEIGHT = "LBL_WEIGHT";
  static LBL_HEIGHT = "LBL_HEIGHT";
  static LBL_BODY_MASS_INDEX = "LBL_BODY_MASS_INDEX";

  static LBL_SMOKED_QUESTION = "LBL_SMOKED_QUESTION";
  static LBL_TYPE_CIGARETTES = "LBL_TYPE_CIGARETTES";
  static LBL_TYPE_CIGARETTES_PLACEHOLDER_FIELD =
    "LBL_TYPE_CIGARETTES_PLACEHOLDER_FIELD";

  static LBL_STICKS_PER_DAY = "LBL_STICKS_PER_DAY";
  static LBL_OCCUPATION = "LBL_OCCUPATION";
  static LBL_OCCUPATION_PLACEHOLDER_FIELD = "LBL_OCCUPATION_PLACEHOLDER_FIELD";
  static LBL_NOB = "LBL_NOB";
  static LBL_NOB_PLACEHOLDER_FIELD = "LBL_NOB_PLACEHOLDER_FIELD";

  static LBL_MOBILE_PHONE = "LBL_MOBILE_PHONE";
  static LBL_MOBILE_PHONE_PLACEHOLDER_FIELD =
    "LBL_MOBILE_PHONE_PLACEHOLDER_FIELD";

  static LBL_OFFICE_PHONE = "LBL_OFFICE_PHONE";
  static LBL_OFFICE_PHONE_PLACEHOLDER_FIELD =
    "LBL_OFFICE_PHONE_PLACEHOLDER_FIELD";

  static LBL_EMAIL = "LBL_EMAIL";
  static LBL_EMAIL_PLACEHOLDER_FIELD = "LBL_EMAIL_PLACEHOLDER_FIELD";

  static LBL_EMPLOYER_COMPANY_NAME = "LBL_EMPLOYER_COMPANY_NAME";
  static LBL_EMPLOYER_COMPANY_NAME_PLACEHOLDER_FIELD =
    "LBL_EMPLOYER_COMPANY_NAME_PLACEHOLDER_FIELD";

  static LBL_BANK_NAME = "LBL_BANK_NAME";
  static LBL_BANK_NAME_PLACEHOLDER_FIELD = "LBL_BANK_NAME_PLACEHOLDER_FIELD";
  static LBL_TYPE_FINANCING = "LBL_TYPE_FINANCING";
  static LBL_TYPE_FINANCING_PLACEHOLDER_FIELD =
    "LBL_TYPE_FINANCING_PLACEHOLDER_FIELD";
  static LBL_CATEGORY_BANK = "LBL_CATEGORY_BANK";
  static LBL_CATEGORY_BANK_PLACEHOLDER_FIELD =
    "LBL_CATEGORY_BANK_PLACEHOLDER_FIELD";

  static LBL_BANK_FINANCING_RATE = "LBL_BANK_FINANCING_RATE";
  static LBL_FINANCED = "LBL_FINANCED";

  static LBL_IMPORTANT_NOTICE = "LBL_IMPORTANT_NOTICE";
  static LBL_IMPORTANT_NOTICE_DESC = "LBL_IMPORTANT_NOTICE_DESC";
  static LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS =
    "LBL_IMPORTANT_NOTICE_PENDING_PROPOSAL_DETAILS";
  static LBL_IMPORTANT_NOTICE_DESC_PENDING_PROPOSAL_DETAILS =
    "LBL_IMPORTANT_NOTICE_DESC_PENDING_PROPOSAL_DETAILS";
  static LBL_PERSONAL_COVERED_BANK_ACCOUNT_NO =
    "LBL_PERSONAL_COVERED_BANK_ACCOUNT_NO";
  static LBL_PERSONAL_COVERED_BANK_ACCOUNT_NO_PLACEHOLDER_FIELD =
    "LBL_PERSONAL_COVERED_BANK_ACCOUNT_NO_PLACEHOLDER_FIELD";

  static LBL_STEP2_UPLOAD_DOCUMENTS = "LBL_STEP2_UPLOAD_DOCUMENTS";
  static LBL_STEP2_UPLOAD_DOCUMENTS_DESC = "LBL_STEP2_UPLOAD_DOCUMENTS_DESC";
  static LBL_SAMPLE_TITLE = "LBL_SAMPLE_TITLE";
  static LBL_SAMPLE_DESC = "LBL_SAMPLE_DESC";
  static LBL_SAMPLE_NOTE = "LBL_SAMPLE_NOTE";
  static LBL_MANDATORY_DOCUMENT = "LBL_MANDATORY_DOCUMENT";

  static LBL_STEP3_REVIEW = "LBL_STEP3_REVIEW";
  static LBL_STEP3_REVIEW_DESC = "LBL_STEP3_REVIEW_DESC";

  static LBL_STEP4_CONSENT_DECLARATION = "LBL_STEP4_CONSENT_DECLARATION";
  static LBL_STEP4_CONSENT_DECLARATION_DESC =
    "LBL_STEP4_CONSENT_DECLARATION_DESC";
  static LBL_SEND_REVIEW = "LBL_SEND_REVIEW";

  static LBL_PROPOSAL_SENT_CLIENT_REVIEW = "LBL_PROPOSAL_SENT_CLIENT_REVIEW";
  static LBL_SMS_SENT_CLIENT_REVIEW = "LBL_SMS_SENT_CLIENT_REVIEW";
  static LBL_BACK_DASHBOARD = "LBL_BACK_DASHBOARD";

  static LBL_QUOTATION_DETAILS = "LBL_QUOTATION_DETAILS";
  static LBL_PROPOSAL_DETAILS = "LBL_PROPOSAL_DETAILS";

  static LBL_LOGIN = "LBL_LOGIN";
  static LBL_USERNAME = "LBL_USERNAME";
  static LBL_USERNAME_PLACEHOLDER = "LBL_USERNAME_PLACEHOLDER";
  static LBL_PASSWORD_PLACEHOLDER = "LBL_PASSWORD_PLACEHOLDER";
  static LBL_FORGOT_PASSWORD = "LBL_FORGOT_PASSWORD";
  static ERROR_USERNAME = "ERROR_USERNAME";
  static ERROR_PASSWORD = "ERROR_PASSWORD";

  static LBL_DASHBOARD = "LBL_DASHBOARD";
  static LBL_WELCOME_NOTE = "LBL_WELCOME_NOTE";
  static LBL_PROPOSAL = "LBL_PROPOSAL";
  static LBL_QUOTATION = "LBL_QUOTATION";
  static LBL_LOGOUT = "LBL_LOGOUT";
  static LBL_LOGOUT_CONFIRMATION = "LBL_LOGOUT_CONFIRMATION";

  static LBL_AUTHENTICATION = "LBL_AUTHENTICATION";
  static LBL_AUTHENTICATION_TITLE = "LBL_AUTHENTICATION_TITLE";
  static LBL_ID_NUMBER = "LBL_ID_NUMBER";
  static LBL_ID_NUMBER_PLACEHOLDER = "LBL_ID_NUMBER_PLACEHOLDER";

  static LBL_NEXT = "LBL_NEXT";
  static LBL_SUBMIT = "LBL_SUBMIT";
  static LBL_CANCEL = "LBL_CANCEL";
  static LBL_CLEAR = "LBL_CLEAR";
  static LBL_SUCCESS = "LBL_SUCCESS";

  static LBL_OTP_VERIFICATION = "LBL_OTP_VERIFICATION";
  static LBL_OTP_VERIFICATION_TITLE = "LBL_OTP_VERIFICATION_TITLE";
  static LBL_OTP_VERIFICATION_DESC = "LBL_OTP_VERIFICATION_DESC";
  static LBL_DID_NOT_RECEIVE_OTP = "LBL_DID_NOT_RECEIVE_OTP";
  static LBL_RESEND_OTP = "LBL_RESEND_OTP";

  static LBL_REVIEW_SIGN = "LBL_REVIEW_SIGN";

  static LBL_STEP_PROPOSAL = "LBL_STEP_PROPOSAL";
  static LBL_STEP_DECLARATION = "LBL_STEP_DECLARATION";
  static LBL_STEP_SIGNATURE = "LBL_STEP_SIGNATURE";

  static LBL_STEP_DECLARATION_TITLE = "LBL_STEP_DECLARATION_TITLE";
  static LBL_STEP_DECLARATION_DESC = "LBL_STEP_DECLARATION_DESC";

  static LBL_STEP_SIGNATURE_TITLE = "LBL_STEP_SIGNATURE_TITLE";

  static LBL_HELLO = "LBL_HELLO";
  static LBL_WELCOME = "LBL_WELCOME";
  static LBL_PENDING_SUBMISSION = "LBL_PENDING_SUBMISSION";
  static LBL_RECENT_ACTIVITIES = "LBL_RECENT_ACTIVITIES";
  static LBL_OVERALL_JOURNEY = "LBL_OVERALL_JOURNEY";

  static LBL_TRACK_PROPOSAL_PROGRESS = "LBL_TRACK_PROPOSAL_PROGRESS";
  static LBL_ADVERTISEMENT = "LBL_ADVERTISEMENT";

  static LBL_SUBMISSION_SUCCESS = "LBL_SUBMISSION_SUCCESS";
  static LBL_SUBMISSION_SUCCESS_DESC = "LBL_SUBMISSION_SUCCESS_DESC";

  static LBL_WEEKLY = "LBL_WEEKLY";
  static LBL_MONTHLY = "LBL_MONTHLY";
  static LBL_YEARLY = "LBL_YEARLY";
  static LBL_QUOTATION_GENERATED = "LBL_QUOTATION_GENERATED";
  static LBL_PROPOSAL_SUBMITTED = "LBL_PROPOSAL_SUBMITTED";

  static LBL_PERSONAL_DETAILS = "LBL_PERSONAL_DETAILS";
  static LBL_FINANCIAL_DETAILS = "LBL_FINANCIAL_DETAILS";
  static LBL_TAKAFUL_DETAILS = "LBL_TAKAFUL_DETAILS";
  static LBL_REVIEW_SUBMIT = "LBL_REVIEW_SUBMIT";

  static LBL_STEP = "LBL_STEP";
  static LBL_STEP1_PERSONAL_DETAILS = "LBL_STEP1_PERSONAL_DETAILS";
  static LBL_STEP1_PERSONAL_DETAILS_DESC = "LBL_STEP1_PERSONAL_DETAILS_DESC";
  static LBL_NAME = "LBL_NAME";
  static LBL_NAME_PLACEHOLDER_FIELD = "LBL_NAME_PLACEHOLDER_FIELD";
  static ERR_NAME_1 = "ERR_NAME_1";
  static ERR_NAME_2 = "ERR_NAME_2";
  static ERR_NAME_3 = "ERR_NAME_3";
  static ERR_NAME_4 = "ERR_NAME_4";
  static ERR_NAME_5 = "ERR_NAME_5";
  static ERR_NAME_6 = "ERR_NAME_6";
  static ERR_NAME_7 = "ERR_NAME_7";
  static LBL_ID_TYPE = "LBL_ID_TYPE";
  static LBL_ID_TYPE_PLACEHOLDER_FIELD = "LBL_ID_TYPE_PLACEHOLDER_FIELD";
  static LBL_NEW_NRIC_NO = "LBL_NEW_NRIC_NO";
  static LBL_NEW_NRIC_NO_PLACEHOLDER_FIELD =
    "LBL_NEW_NRIC_NO_PLACEHOLDER_FIELD";
  static LBL_OTHER_NRIC_NO = "LBL_OTHER_NRIC_NO";
  static LBL_OTHER_NRIC_NO_PLACEHOLDER_FIELD =
    "LBL_OTHER_NRIC_NO_PLACEHOLDER_FIELD";
  static LBL_DOB = "LBL_DOB";
  static LBL_DOB_PLACEHOLDER_FIELD = "LBL_DOB_PLACEHOLDER_FIELD";
  static LBL_AGE_ANB = "LBL_AGE_ANB";
  static LBL_AGE_ANB_INPUT = "LBL_AGE_ANB_INPUT";
  static LBL_DATE_QUOTATION = "LBL_DATE_QUOTATION";

  static LBL_DISCARD = "LBL_DISCARD";
  static LBL_SAVE_CLOSE = "LBL_SAVE_CLOSE";

  static LBL_STEP2_FINANCIAL_DETAILS = "LBL_STEP2_FINANCIAL_DETAILS";
  static LBL_STEP2_FINANCIAL_DETAILS_DESC = "LBL_STEP2_FINANCIAL_DETAILS_DESC";
  static LBL_FINANCING_BANK = "LBL_FINANCING_BANK";
  static LBL_FINANCING_BANK_PLACEHOLDER_FIELD =
    "LBL_FINANCING_BANK_PLACEHOLDER_FIELD";
  static LBL_FINANCING_ACCOUNT_NO = "LBL_FINANCING_ACCOUNT_NO";
  static LBL_FINANCING_ACCOUNT_NO_PLACEHOLDER_FIELD =
    "LBL_FINANCING_ACCOUNT_NO_PLACEHOLDER_FIELD";
  static LBL_BANK_REFERENCE_NO = "LBL_BANK_REFERENCE_NO";
  static LBL_BANK_REFERENCE_NO_PLACEHOLDER_FIELD =
    "LBL_BANK_REFERENCE_NO_PLACEHOLDER_FIELD";
  static LBL_ELIGIBLE_SCHEME = "LBL_ELIGIBLE_SCHEME";
  static LBL_FINANCING_AMOUNT = "LBL_FINANCING_AMOUNT";
  static LBL_FINANCING_PERCENTAGE = "LBL_FINANCING_PERCENTAGE";
  static LBL_COVERED_FINANCING_AMOUNT = "LBL_COVERED_FINANCING_AMOUNT";
  static LBL_ASSUMED_BANK_RATE = "LBL_ASSUMED_BANK_RATE";
  static LBL_FINANCING_PERIOD = "LBL_FINANCING_PERIOD";
  static LBL_FINANCING_PERIOD_A = "LBL_FINANCING_PERIOD_A";
  static LBL_FINANCING_PERIOD_PLACEHOLDER_FIELD =
    "LBL_FINANCING_PERIOD_PLACEHOLDER_FIELD";
  static LBL_DEFERMENT_PERIOD = "LBL_DEFERMENT_PERIOD";
  static LBL_DEFERMENT_PERIOD_B = "LBL_DEFERMENT_PERIOD_B";
  static LBL_DEFERMENT_PERIOD_PLACEHOLDER_FIELD =
    "LBL_DEFERMENT_PERIOD_PLACEHOLDER_FIELD";

  static LBL_STEP3_TAKAFUL_DETAILS = "LBL_STEP3_TAKAFUL_DETAILS";
  static LBL_STEP3_TAKAFUL_DETAILS_DESC = "LBL_STEP3_TAKAFUL_DETAILS_DESC";
  static LBL_TERM_COVERAGE = "LBL_TERM_COVERAGE";
  static LBL_TERM_COVERAGE_A_B = "LBL_TERM_COVERAGE_A_B";
  static LBL_TERM_COVERAGE_PLACEHOLDER_FIELD =
    "LBL_TERM_COVERAGE_PLACEHOLDER_FIELD";
  static LBL_INITIAL_SUM_COVERED = "LBL_INITIAL_SUM_COVERED";
  static LBL_CONTRIBUTION_AMOUNT = "LBL_CONTRIBUTION_AMOUNT";
  static LBL_CONTRIBUTION_MODE = "LBL_CONTRIBUTION_MODE";
  static LBL_CASH = "LBL_CASH";
  static LBL_CONTRIBUTION_TYPE = "LBL_CONTRIBUTION_TYPE";
  static LBL_CONTRIBUTION_TYPE_PLACEHOLDER_FIELD =
    "LBL_CONTRIBUTION_TYPE_PLACEHOLDER_FIELD";

  static ERR_NRIC_1 = "ERR_NRIC_1";
  static ERR_NRIC_2 = "ERR_NRIC_2";

  static ERROR_EMPTY_VALUE = "ERROR_EMPTY_VALUE";

  static LBL_STEP4_REVIEW_SUBMIT = "LBL_STEP4_REVIEW_SUBMIT";
  static LBL_STEP4_REVIEW_SUBMIT_DESC = "LBL_STEP4_REVIEW_SUBMIT_DESC";
  static LBL_GENERATED_DOCUMENTS = "LBL_GENERATED_DOCUMENTS";
  static LBL_CREATE_QUOTATION = "LBL_CREATE_QUOTATION";

  static LBL_GENERATE_PROPOSAL = "LBL_GENERATE_PROPOSAL";
  static LBL_PROVIDE_DETAILS = "LBL_PROVIDE_DETAILS";
  static LBL_UPLOAD_DOCUMENTS = "LBL_UPLOAD_DOCUMENTS";
  static LBL_REVIEW = "LBL_REVIEW";
  static LBL_CONSENT_DECLARATION = "LBL_CONSENT_DECLARATION";

  //TABS Label
  static LBL_MY_PROFILE = "LBL_MY_PROFILE";
  static LBL_PRUDENTIAL_PROFILE = "LBL_PRUDENTIAL_PROFILE";
  static LBL_UOB_PROFILE = "LBL_UOB_PROFILE";
  static LBL_QUICKLINKS = "LBL_QUICKLINKS";

  static LBL_QUICKLINKS_HEADER = "LBL_QUICKLINKS_HEADER";
  static LBL_USER_PROFILE_HEADER = "LBL_USER_PROFILE_HEADER";
  static LBL_PRUDENTIAL_PROFILE_HEADER = "LBL_PRUDENTIAL_PROFILE_HEADER";
  static LBL_UOB_PROFILE_HEADER = "LBL_UOB_PROFILE_HEADER";
  static LBL_SALES_REPRESENTATIVE_CODE = "LBL_SALES_REPRESENTATIVE_CODE";
  static LBL_SALES_REPRESENTATIVE_ID = "LBL_SALES_REPRESENTATIVE_ID";
  static LBL_SALES_REPRESENTATIVE_STAFF_ID =
    "LBL_SALES_REPRESENTATIVE_STAFF_ID";
  static LBL_SALES_REPRESENTATIVE_OFFICE = "LBL_SALES_REPRESENTATIVE_OFFICE";
  static LBL_EMAIL_ADDRESS = "LBL_EMAIL_ADDRESS";
  static LBL_CONTACT_NUMBER = "LBL_CONTACT_NUMBER";
  static LBL_SUPERVISOR_NAME_AND_CODE = "LBL_SUPERVISOR_NAME_AND_CODE";
  static LBL_SUPERVISOR_NAME = "LBL_SUPERVISOR_NAME";
  static LBL_SUPERVISOR_CODE = "LBL_SUPERVISOR_CODE";

  static LBL_SALES_REPRESENTATIVE_NAME = "LBL_SALES_REPRESENTATIVE_NAME";
  static LBL_BRANCH_CODE = "LBL_BRANCH_CODE";
  static LBL_REFERRAL_CODE = "LBL_REFERRAL_CODE";
  static LBL_BANK_CAMPAIGN_CODE = "LBL_BANK_CAMPAIGN_CODE";
  static LBL_MS_SPECIAL_INSTRUCTION = "LBL_MS_SPECIAL_INSTRUCTION";
  static LBL_ERROR_REFERRAL_CODE = "LBL_ERROR_REFERRAL_CODE";

  static LBL_PREMIUM_AMOUNT = "LBL_PREMIUM_AMOUNT";
  static LBL_BASIC_AMOUNT = "LBL_BASIC_AMOUNT";
  static LBL_ROP_AMOUNT = "LBL_ROP_AMOUNT";
  static LBL_TOTAL_AMOUNT = "LBL_TOTAL_AMOUNT";
  static LBL_SUM_ASSURED = "LBL_SUM_ASSURED";
  static LBL_SALES_REPRESENTATIVE_DETAILS = "LBL_SALES_REPRESENTATIVE_DETAILS";
  static LBL_ANNUAL_INCOME = "LBL_ANNUAL_INCOME";
  static LBL_FATCA = "LBL_FATCA";
  static LBL_RELATIONSHIP = "LBL_RELATIONSHIP";
  static LBL_INSURANCE_CERTIFICATE_DELIVERY =
    "LBL_INSURANCE_CERTIFICATE_DELIVERY";
  static LBL_STEP2_HEALTH_QUESTIONNARIES = "LBL_STEP2_HEALTH_QUESTIONNARIES";
  static LBL_STEP2_HEALTH_QUESTIONNARIES_DESC =
    "LBL_STEP2_HEALTH_QUESTIONNARIES_DESC";
  static LBL_HEALTH_QUESTIONNARIES = "LBL_HEALTH_QUESTIONNARIES";
  static LBL_HEALTH_DECLARATION = "LBL_HEALTH_DECLARATION";
  static RESIDENCETELNO = "RESIDENCETELNO";
  static BUSINESSTELNO = "BUSINESSTELNO";

  static LBL_SECTION1_1_DECLARATION_TITLE = "LBL_SECTION1_1_DECLARATION_TITLE";
  static LBL_SECTION1_1_DECLARATION_DESC = "LBL_SECTION1_1_DECLARATION_DESC";
  static LBL_SECTION1_2_DECLARATION_TITLE = "LBL_SECTION1_2_DECLARATION_TITLE";
  static LBL_SECTION1_2_DECLARATION_DESC = "LBL_SECTION1_2_DECLARATION_DESC";
  static LBL_SECTION1_3_DECLARATION_TITLE = "LBL_SECTION1_3_DECLARATION_TITLE";
  static LBL_SECTION1_3_DECLARATION_DESC = "LBL_SECTION1_3_DECLARATION_DESC";

  static LBL_PRIVACY_POLICY = "LBL_PRIVACY_POLICY";

  static LBL_SECTION2_1_DECLARATION_TITLE = "LBL_SECTION2_1_DECLARATION_TITLE";
  static LBL_SECTION2_1_DECLARATION_DESC = "LBL_SECTION2_1_DECLARATION_DESC";
  static LBL_SECTION2_2_DECLARATION_TITLE = "LBL_SECTION2_2_DECLARATION_TITLE";
  static LBL_SECTION2_2_DECLARATION_DESC = "LBL_SECTION2_2_DECLARATION_DESC";
  static LBL_SECTION2_3_DECLARATION_TITLE = "LBL_SECTION2_3_DECLARATION_TITLE";
  static LBL_SECTION2_3_DECLARATION_DESC = "LBL_SECTION2_3_DECLARATION_DESC";
  static LBL_SECTION2_4_DECLARATION_TITLE = "LBL_SECTION2_4_DECLARATION_TITLE";
  static LBL_SECTION2_4_DECLARATION_DESC = "LBL_SECTION2_4_DECLARATION_DESC";

  static LBL_SECTION2_STATIC_WORDS = "LBL_SECTION2_STATIC_WORDS";
  static LBL_GENERAL_DECLARATION = "LBL_GENERAL_DECLARATION";

  static LBL_SECTION3_1_DECLARATION_TITLE = "LBL_SECTION3_1_DECLARATION_TITLE";
  static LBL_SECTION3_1_DECLARATION_DESC = "LBL_SECTION3_1_DECLARATION_DESC";
  static LBL_SECTION3_2_DECLARATION_TITLE = "LBL_SECTION3_2_DECLARATION_TITLE";
  static LBL_SECTION3_2_DECLARATION_DESC = "LBL_SECTION3_2_DECLARATION_DESC";
  static LBL_SECTION3_3_DECLARATION_TITLE = "LBL_SECTION3_3_DECLARATION_TITLE";
  static LBL_SECTION3_3_DECLARATION_DESC = "LBL_SECTION3_3_DECLARATION_DESC";
  static LBL_SECTION3_4_DECLARATION_TITLE = "LBL_SECTION3_4_DECLARATION_TITLE";
  static LBL_SECTION3_4_DECLARATION_DESC = "LBL_SECTION3_4_DECLARATION_DESC";
  static LBL_SECTION3_5_DECLARATION_TITLE = "LBL_SECTION3_5_DECLARATION_TITLE";
  static LBL_SECTION3_5_DECLARATION_DESC = "LBL_SECTION3_5_DECLARATION_DESC";
  static LBL_SECTION3_6_DECLARATION_TITLE = "LBL_SECTION3_6_DECLARATION_TITLE";
  static LBL_SECTION3_6_DECLARATION_DESC = "LBL_SECTION3_6_DECLARATION_DESC";
  static LBL_SECTION3_7_DECLARATION_TITLE = "LBL_SECTION3_7_DECLARATION_TITLE";
  static LBL_SECTION3_7_DECLARATION_DESC = "LBL_SECTION3_7_DECLARATION_DESC";

  static LBL_CONSENT = "LBL_CONSENT";
  static LBL_SECTION4_1_DECLARATION_TITLE = "LBL_SECTION4_1_DECLARATION_TITLE";
  static LBL_SECTION4_1_DECLARATION_DESC = "LBL_SECTION4_1_DECLARATION_DESC";
  static LBL_SECTION4_2_DECLARATION_TITLE = "LBL_SECTION4_2_DECLARATION_TITLE";
  static LBL_SECTION4_2_DECLARATION_DESC = "LBL_SECTION4_2_DECLARATION_DESC";
  static LBL_SECTION4_3_DECLARATION_TITLE = "LBL_SECTION4_3_DECLARATION_TITLE";
  static LBL_SECTION4_3_DECLARATION_DESC = "LBL_SECTION4_3_DECLARATION_DESC";

  static LBL_SECTION5_DECLARATION_CONFIRM = "LBL_SECTION5_DECLARATION_CONFIRM";

  static LBL_ERROR_WEIGHT = "LBL_ERROR_WEIGHT";
  static LBL_ERROR_HEIGHT = "LBL_ERROR_HEIGHT";

  static LBL_BANK_CAMPAIGN_CODE_DETAIL = "LBL_BANK_CAMPAIGN_CODE_DETAIL";
  static LBL_MS_SPECIAL_INSTRUCTION_DETAIL =
    "LBL_MS_SPECIAL_INSTRUCTION_DETAIL";
  static LBL_SMOKED_SUBLABEL = "LBL_SMOKED_SUBLABEL";

  static LBL_CORRESPONDENCE_ADDRESS_DETAIL =
    "LBL_CORRESPONDENCE_ADDRESS_DETAIL";
  static LBL_RESIDENT_ADDRESS_DETAIL = "LBL_RESIDENT_ADDRESS_DETAIL";
  static LBL_EMPLOYER_ADDRESS_DETAIL = "LBL_EMPLOYER_ADDRESS_DETAIL";
  static LBL_RESIDENT_ADDRESS_1 = "LBL_RESIDENT_ADDRESS_1";
  static LBL_RESIDENT_ADDRESS_2 = "LBL_RESIDENT_ADDRESS_2";
  static LBL_RESIDENT_ADDRESS_3 = "LBL_RESIDENT_ADDRESS_3";

  static LBL_EMPLOYER_ADDRESS_1 = "LBL_EMPLOYER_ADDRESS_1";
  static LBL_EMPLOYER_ADDRESS_2 = "LBL_EMPLOYER_ADDRESS_2";
  static LBL_EMPLOYER_ADDRESS_3 = "LBL_EMPLOYER_ADDRESS_3";

  static LBL_MALAYSIA_RESIDENT_ADDRESS_1 = "LBL_MALAYSIA_RESIDENT_ADDRESS_1";
  static LBL_MALAYSIA_EMPLOYER_ADDRESS_1 = "LBL_MALAYSIA_EMPLOYER_ADDRESS_1";

  static LBL_ALSO_SAME_ADDRESS_TO_CORRESPONDENCE =
    "LBL_ALSO_SAME_ADDRESS_TO_CORRESPONDENCE";
    static LBL_ALSO_SAME_AS_CORRESPONDENCE =
    "LBL_ALSO_SAME_AS_CORRESPONDENCE";

  static ERROR_POSTCODE_VALIDATION_DOUBLE_SPACE =
    "ERROR_POSTCODE_VALIDATION_DOUBLE_SPACE";

  static LBL_TERM_AND_CONDITION = "LBL_TERM_AND_CONDITION";
  static LBL_STEP_DECLARATION_AND_SIGN = "LBL_STEP_DECLARATION_AND_SIGN";
  static LBL_QR_EXPIRED = "LBL_QR_EXPIRED";
  static LBL_QR_INVALID = "LBL_QR_INVALID";
  static LBL_QR_CODE_EXPIRED = "LBL_QR_CODE_EXPIRED";
  static LBL_QR_CODE_INVALID = "LBL_QR_CODE_INVALID";
  static LBL_PROPOSAL_QR_EXPIRED_DESC = "LBL_PROPOSAL_QR_EXPIRED_DESC";
  static LBL_PROPOSAL_QR_INVALID_DESC = "LBL_PROPOSAL_QR_INVALID_DESC";
  static LBL_CANCEL_DIALOG_TITLE_CLIENT = "LBL_CANCEL_DIALOG_TITLE_CLIENT";
  static LBL_CANCEL_DIALOG_DESC_CLIENT = "LBL_CANCEL_DIALOG_DESC_CLIENT";
  static LBL_ESIGNATURE = "LBL_ESIGNATURE";
  static LBL_DIALOG_VIEW_TITLE = "LBL_DIALOG_VIEW_TITLE";
  static LBL_DIALOG_VIEW_DESC = "LBL_DIALOG_VIEW_DESC";
  static LBL_DIALOG_VIEW_CONFIRM = "LBL_DIALOG_VIEW_CONFIRM";
  static LBL_DIALOG_VIEW_DECLINE = "LBL_DIALOG_VIEW_DECLINE";
  static LBL_DECLARATION_ACKNOWLEGDE = "LBL_DECLARATION_ACKNOWLEGDE";
  static LBL_DECLARATION_ACKNOWLEGDE2 = "LBL_DECLARATION_ACKNOWLEGDE2";
  static LBL_DECLARATION_ACKNOWLEGDE3 = "LBL_DECLARATION_ACKNOWLEGDE3";
  static LBL_DECLARATION_IMPORTANT_NOTE = "LBL_DECLARATION_IMPORTANT_NOTE";
  static LBL_DECLARATION_NOTE = "LBL_DECLARATION_NOTE";
  static LBL_SIGNATURE_DECLARATION = "LBL_SIGNATURE_DECLARATION";

  static ERROR_REQUEST_TAC_LIMIT = "ERROR_REQUEST_TAC_LIMIT";
}


export default Labels;
